import { CenteringDiv, FlexRowDiv, H1, FlexDiv } from 'components/generic/HomePageComponents'
import { DarkButton, FeaturedProfilesImage } from './Styled'
import ProfileCardsContainer from './ProfileCardsContainer'
import ProfileCard from './ProfileCard'
import dev from 'utils/dev'

const FeaturedProfiles = ({
  listings,
  featuredProvidersHeader,
  featuredProvidersCta,
  featuredProvidersCtaLink,
  imageURL,
}) => (
  <FlexRowDiv bg='#FBFBFB' flexWrap='wrap'>
    <CenteringDiv>
      <H1
        textAlign={{ _: 'center', tablet: 'left' }}
        ml='10px'
        mr='10px'
        fontSize={{ _: '25px', desktop: '45px' }}
      >
        {featuredProvidersHeader}
      </H1>

      <ProfileCardsContainer>
        {listings.length >= 3 ? (
          <>
            <ProfileCard card={listings[0]} />
            <ProfileCard card={listings[1]} display={{ _: 'none', desktop: 'inline' }} />
            <ProfileCard card={listings[2]} display={{ _: 'none', desktop: 'inline' }} />
          </>
        ) : (
          <NoListings />
        )}
      </ProfileCardsContainer>
      <DarkButton
        whiteSpace='nowrap'
        mt='35px'
        padding={{ _: '13px 28px', tablet: '13px 38px', desktop: '13px 48px' }}
        maxWidth={{ _: '325px', tablet: '415px' }}
        fontSize={{ _: '18px', desktop: '25px' }}
        href={featuredProvidersCtaLink}
        rel='nofollow'
      >
        {featuredProvidersCta}
      </DarkButton>
    </CenteringDiv>
    <FlexDiv flexBasis='100%'>
      <FeaturedProfilesImage
        src={imageURL}
        height={{ _: '0px', desktop: '164px' }}
        display={{ _: 'none', desktop: 'inline' }}
        alt='Featured Profiles'
      />
    </FlexDiv>
  </FlexRowDiv>
)

/**
 * Logs error if there are no listings.
 * This should never be rendered in production so it just returns null.
 * This should only be rendered when the `careguide` app was not seeded or indexed correctly.
 * See Slack thread for details:
 *
 * - https://careguide.slack.com/archives/C047PDMDU/p1605028786121700
 */
function NoListings() {
  dev.error(
    'No listings found. This is likely an issue with your database setup. \r\t' +
      'Please check that your database has been seeded and indexed.'
  )
  return null
}

export default FeaturedProfiles
